<ng-container *ngIf="document else loading">
	<div class="card-portal">
		<div class="card-header">
			<div class="card-header-right">
				<mat-icon svgIcon="icon_invoice" class="header-margin-right"></mat-icon>
				<div>{{document.typeDescription ? document.typeDescription :
					UNDERSCORE}}</div>
			</div>
			<div>
				<div class="card-header-label" translate>commercial-documents.invoice-number</div>
				<a class="card-header-value" [routerLink]="['/commercial-documents/cards/invoice-card', document.id]">
					{{ document.name ? document.name : UNDERSCORE }}
				</a>
			</div>
			<div>
				<div class="card-header-label" translate>commercial-documents.invoice-type</div>
				<div>{{ document.subtypeDescription ? document.subtypeDescription : UNDERSCORE }}</div>
			</div>
			<div class="card-header-double-span card-header-right">
				<mat-icon svgIcon="calendar" class="header-margin-right"></mat-icon>
				<div class="card-container-column">
					<span class="card-header-label" translate>datacenter-filter.creation-date</span>
					<span>{{ (document.date ? document.date : UNDERSCORE) | copoDate:'date' }}</span>
				</div>
			</div>

			<div class="card-container-link">
				<a mat-icon-button [href]="getDocumentURL(document.id, document.name) | copoSafeUrl" target="_blank"
					type="application/pdf" class="icon-color" [title]="'quapp.action.view' | translate">
					<mat-icon svgIcon="md:eye"></mat-icon>
				</a>
				<a mat-icon-button [href]="downloadDocument(document.id, document.name) | copoSafeUrl" target="_blank"
					type="application/pdf" class="icon-color" [title]="'sb.Download' | translate">
					<mat-icon svgIcon="md:download"></mat-icon>
				</a>
			</div>
		</div>
		<div class="card-content">
			<div>
				<div class="card-content-label" translate>{{orderLable}}</div>
				<div *ngFor="let docLine of orderNumbers; let i = index">
					<div *ngIf="i < 3">
						{{docLine.key}}
					</div>
				</div>
			</div>
			<div>
				<div class="card-content-label" translate>commercial-documents.payment-due-to</div>
				<div>{{ document.paymentDueDate ? (document.paymentDueDate | copoDate:'date') : UNDERSCORE }}</div>
			</div>
			<div class="card-header-double-span card-container-column">
				<div class="card-container-two-columns-row">
					<span class="card-content-label" translate>commercial-documents.batch-number</span>
					<span class="card-content-label" translate>commercial-documents.mill</span>
				</div>
				<div *ngFor="let docLine of document.documentLines; let i = index">
					<div class="card-container-two-columns-row" *ngIf="i < 3">
						<span class="order-weight-label">
							{{ docLine.batchNumber ? docLine.batchNumber : UNDERSCORE}}
						</span>
						<span>{{ docLine.millDescription ? docLine.millDescription : UNDERSCORE }}</span>
					</div>
				</div>
			</div>

			<div class="card-container-link-row">
				<span class="card-container-column card-container-link-span bold-label"
					translate>commercial-documents.invoice-quantity</span>
				<div class="card-container-column">
									<span class="label-orange-color">{{formatInvoicedQuantity(document)}}</span>
					<span
																			class="card-column-center label-orange-color">{{document.invoiceAmount
																			| copoNumber:'amount'}} &nbsp; {{document.invoiceCurrency}}</span>
				</div>
			</div>
			<div class="card-container-column card-column-end">
				<a mat-button color="primary" *ngIf="document.documentLines.length > 3"
					(click)="callFilter(document, 'batch')" [routerLink]="['/order-tracking/batch/list']">
					<span translate>order.card.document.display.batches</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</a>
				<a mat-button color="primary" *ngIf="orderNumbers.length > 3" (click)="callFilter(document, 'order')"
					[routerLink]="['/order-tracking/order/list']">
					<span translate>commercial-documents.display-all-orders</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</a>
			</div>
		</div>
	</div>
	<div class="card-mobile">
		<div class="card-header">
			<div class="card-header-left">
				<mat-icon svgIcon="icon_invoice" class="header-margin-right"></mat-icon>
				<span class="header-margin-right overflow-wrap">{{document.typeDescription ? document.typeDescription :
					UNDERSCORE}}</span>
			</div>
			<div class="card-container-link">
				<a mat-icon-button [href]="getDocumentURL(document.id, document.name) | copoSafeUrl" target="_blank"
					type="application/pdf" class="icon-color" [title]="'quapp.action.view' | translate">
					<mat-icon svgIcon="md:eye"></mat-icon>
				</a>
				<a mat-icon-button [href]="downloadDocument(document.id, document.name) | copoSafeUrl" target="_blank"
					type="application/pdf" class="icon-color" [title]="'sb.Download' | translate">
					<mat-icon svgIcon="md:download"></mat-icon>
				</a>
			</div>
		</div>
		<div class="card-content">
			<div class="content-grid-mobile">
				<div class="card-container-column">
					<span class="card-content-label" translate>commercial-documents.invoice-number</span>
					<a class="card-header-value"
						[routerLink]="['/commercial-documents/cards/invoice-card', document.id]">
						{{ document.name ? document.name : UNDERSCORE}}
					</a>
				</div>
				<div class="card-container-column">
					<div class="card-content-label" translate>commercial-documents.invoice-type</div>
					<div class="overflow-wrap">{{ document.subtypeDescription ? document.subtypeDescription : UNDERSCORE }}</div>
				</div>
				<div class="card-header-right">
					<mat-icon svgIcon="calendar" class="header-margin-right grey-icon"></mat-icon>
					<div class="card-container-column">
						<span class="card-content-label" translate>datacenter-filter.creation-date</span>
						<span>{{ (document.date ? document.date : UNDERSCORE) | copoDate:'date' }}</span>
					</div>
				</div>
				<div class="card-container-column">
					<span class="card-content-label" translate>{{orderLable}}</span>
					<span class="overflow-wrap" *ngFor="let docLine of orderNumbers; let i = index">
						<span *ngIf="i < 3">
							{{docLine.key}}
						</span>
					</span>
				</div>
				<div class="card-header-double-span">
					<div class="card-container-two-columns-row">
						<span class="card-content-label" translate>commercial-documents.batch-number</span>
						<span class="card-content-label" translate>commercial-documents.mill</span>
					</div>
					<div *ngFor="let docLine of document.documentLines; let i = index">
						<div class="card-container-two-columns-row" *ngIf="i < 3">
							<span class="order-weight-label">
								{{ docLine.batchNumber ? docLine.batchNumber : UNDERSCORE}}
							</span>
							<span class="overflow-wrap">{{ docLine.millDescription ? docLine.millDescription : UNDERSCORE }}</span>
						</div>
					</div>
				</div>
				<div class="card-container-column">
					<div class="card-content-label" translate>commercial-documents.payment-due-to</div>
					<div>{{ document.paymentDueDate ? (document.paymentDueDate | copoDate:'date') : UNDERSCORE
						}}</div>
				</div>
				<div class="card-container-link-row">
					<span class="card-container-column card-container-link-span bold-label"
						translate>commercial-documents.invoice-quantity</span>
					<div class="card-container-column">
						<span class="overflow-wrap label-orange-color">{{formatInvoicedQuantity(document)}}</span>
						<span
							class="overflow-wrap card-column-center label-orange-color">{{document.invoiceAmount
							| copoNumber:'amount'}} &nbsp; {{document.invoiceCurrency}}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="card-container-column card-column-end">
			<div class="card-container-link" *ngIf="document.documentLines.length > 3">
				<a mat-button color="primary" (click)="callFilter(document, 'batch')"
					[routerLink]="['/order-tracking/batch/list']">
					<span translate>order.card.document.display.batches</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</a>
			</div>
			<div class="card-container-link" *ngIf="orderNumbers.length > 3">
				<a mat-button color="primary" (click)="callFilter(document, 'order')"
					[routerLink]="['/order-tracking/order/list']">
					<span translate>commercial-documents.display-all-orders</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</a>
			</div>
		</div>
	</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>